import modal from 'components/Modal/Modal.reducer';
import tablePaginationReducer from 'components/Table/partials/TablePagination/TablePagination.reducer';
import profileReducer from 'pages/profile/profile.reducer';
import { localizeReducer as localize } from 'react-localize-redux';
import { combineReducers } from 'redux';
import accountMsReducer from 'services/account-ms';
import adobeLaunchReducer from 'services/adobe-launch/adobe-launch.reducer';
import apiReducer from 'services/api/api.reducer';
import { api } from 'services/api/api.rtk';
import barcodeReducer from 'services/barcode/barcode.reducer';
import betsReducer from 'services/bets/bets.reducer';
import bonusReducer from 'services/bonus/bonus.reducer';
import cmsContentReducer from 'services/cmsContent/cmsContent.reducer';
import communityAccountReducer from 'services/communityAccount/communityAccount.reducers';
import favoritesReducer from 'services/favorites/favorites.reducer';
import geoReducer from 'services/geo/geo.reducer';
import grantReducer from 'services/grant/grant.reducer';
import inboxReducer from 'services/inbox/inbox.reducer';
import inviteReducer from 'services/invite/invite.reducer';
import jumioReducer from 'services/jumio/jumio.reducer';
import lotteryItalyReducer from 'services/lotteryItaly/lotteryItaly.reducer';
import loyaltyBonusReducer from 'services/loyalty/loyalty.reducers';
import movementsReducer from 'services/movements/movements.reducer';
import oAuthReducer from 'services/oauth/oauth.reducer';
import otpCoreMsReducer from 'services/otp-core-ms';
import OtpReducer from 'services/otp/otp.reducer';
import pendingSessionsReducer from 'services/pendingSessions/pendingSessions.reducer';
import playResponsiblyReducer from 'services/playResponsibly/playResponsibly.reducer';
import prefixReducer from 'services/prefix/prefix.reducer';
import privacyReducer from 'services/privacy/privacy.reducer';
import queryReducer from 'services/query/query.reducer';
import rechargesReducer from 'services/recharges/recharges.reducer';
import rechargesAutomaticReducer from 'services/rechargesAutomatic/rechargesAutomatic.reducer';
import selfExclusionReducer from 'services/selfExclusion/selfExclusion.reducer';
import { endUserSession } from 'services/session/session.actions';
import sessionReducer from 'services/session/session.reducer';
import subscriptionReducer from 'services/subscription/subscription.reducers';
import userReducer from 'services/user/user.reducer';
import verifyEmailReducer from 'services/verifyEmail/verifyEmail.reducer';
import withdrawalReducer from 'services/withdrawal/withdrawal.reducer';
import withResetReducerOn from 'utils/functions/withResetReducerOn';

/**
 * rootReducer
 *
 * Here we gather all the single reducers that controls the application state.
 */
const rootReducer = combineReducers({
  modal,
  localize,
  api: apiReducer,
  [api.reducerPath]: api.reducer,
  recharges: rechargesReducer,
  rechargesAutomatic: rechargesAutomaticReducer,
  withdrawal: withdrawalReducer,
  session: sessionReducer,
  user: userReducer,
  communityAccount: communityAccountReducer,
  geo: geoReducer,
  tablePagination: tablePaginationReducer,
  barcode: barcodeReducer,
  giocaGiusto: playResponsiblyReducer,
  profilePage: profileReducer,
  movements: movementsReducer,
  grant: grantReducer,
  bets: betsReducer,
  inbox: inboxReducer,
  bonus: bonusReducer,
  invite: inviteReducer,
  privacy: privacyReducer,
  cmsContent: cmsContentReducer,
  verifyEmail: verifyEmailReducer,
  lotteryItaly: lotteryItalyReducer,
  favorites: favoritesReducer,
  otp: OtpReducer,
  otpCore: otpCoreMsReducer,
  jumio: jumioReducer,
  prefix: prefixReducer,
  subscription: subscriptionReducer,
  adobeLaunch: adobeLaunchReducer,
  accountMs: accountMsReducer,
  loyaltyBonus: loyaltyBonusReducer,
  pendingSessions: pendingSessionsReducer,
  oAuth: oAuthReducer,
  selfExclusion: selfExclusionReducer,
  query: queryReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default withResetReducerOn(rootReducer, (action: any) => {
  return typeof action?.type === 'string' && endUserSession.match(action);
});
